import { useEffect } from 'react';
import useRouter from '@framework/hooks/useNextRouter';
import { REDIRECT_ERROR_URL_WRONG_ID } from '@/creditflowresearch/application/League/constants';

export const useCompanyErrorRedirect = (errorLoadCompany?: string | null) => {
  const { replace } = useRouter();

  useEffect(() => {
    if (errorLoadCompany === REDIRECT_ERROR_URL_WRONG_ID) {
      replace('/404');
    }
  }, [errorLoadCompany, replace]);
};
